import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Image from "next/image"
import ReCAPTCHA from "react-google-recaptcha";
import NewiconA from "../../assets/images/header/modalnew.png";
 import { MultiSelect } from "react-multi-select-component";
import { useRef, useEffect, useState } from "react";
import Link from "next/link";
//import ErrorModal from "../../components/Modal/ErrorModal";
import dynamic from 'next/dynamic';
import { setunewuser } from "../../components/Service/setuscholarship";
import { setumailcnfm } from "../../components/Service/setuscholarship";
const Otpverification = dynamic(() => import("../../components/Modal/Otpverification"));
const Classroom_form = (props) => {

const accommodationOptions = [
  { value: "scribe", label: "Scribe Assistance" },
  { value: "extended_time", label: "Extended Examination Time" },
  { value: "sign_language", label: "Sign Language Interpretation" },
  { value: "screen_reader", label: "Screen Reader Compatible Materials" },
  { value: "large_print", label: "Large Print Materials" },
  { value: "braille", label: "Braille Materials" },
  { value: "wheelchair", label: "Wheelchair Accessibility" },
  { value: "other", label: "Other" },
];

    const [verified, setverified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [attempted, setAttempted] = useState("No");
    const [hasScholarship, setHasScholarship] = useState("No");
    const [selected, setSelected] = useState([]);
    const [formData, setFormData] = useState({ selectedData: '' });
    const [modalOtp, setModalOtp] = useState(false);
    const [modalOtpstatus, setmodalOtpstatus] = useState(null);
    const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
    const [valuephno, setvaluephno] = useState(undefined);
    const [captchaerror, setcaptchaerror] = useState(undefined);
    const [selectedRadio, setSelectedRadio] = useState();
    const [imgerror, setimgerror] = useState(undefined);
    const [base64ImageToUpload, setbase64ImageToUpload] = useState();
    
    const [last8Digits, setLast8Digits] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [RegMobile,setRegMobile] =useState("");
    const pdfRef = useRef();

    const handleChange = (selectedOptions) => {
     setSelected(selectedOptions);
 
     // Convert selected options to JSON string
     const jsonString = JSON.stringify(selectedOptions.map(option => option.value));
     const jsonString2=JSON.parse(jsonString);
     
     // Update the formData state with the comma-separated values
     setFormData({selectedData: jsonString2 });
 };
    const imageUpload = (e) => {
  
    console.log(e.target.files[0].size);
    
        if ((e.target.files[0].size/600) <= 600){
          document.getElementById("fileindex").value = e.target.files[0].name;
          uploadDocument(e,"image");
        }
        
        else {
          setimgerror(true);
          setTimeout(() => {
            setimgerror(false);
          }, 3000);
          document.getElementById("imagefile").value = "";
        }
      };
      const uploadDocument = async (event, type) => {
        const file = event.target.files[0];
        
        console.log(file);
        const base64 = await convertBase64(file);
        console.log(base64);
        const updloadFile = {
          "name": file.name,
          "type": file.type,
          "content": base64.split(",")[1],
          "base64": base64
        }
      
        if (type == "image") {
          setbase64ImageToUpload(updloadFile);
        } 
      };
    
      const convertBase64 = (file) => {
        console.log(file);
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file);
    
          fileReader.onload = () => {
            resolve(fileReader.result);
          };
    
          fileReader.onerror = (error) => {
            reject(error);
          };
        });
      };
    
     
    
    function convertJsonStringToNumber(jsonString) {
        // Parse the JSON string to an object
        const jsonObject = JSON.parse(jsonString);
      
        // Iterate over the keys and convert numeric strings to numbers
        for (const key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)
    && !isNaN(jsonObject[key])) {
            jsonObject[key] = Number(jsonObject[key]);
          }
        }
      
        return jsonObject;
      }

  

    function onChange(value) {
        if (value == null) {
          setverified(false);
        }
        else {
          setverified(true);
        }
    }
   
    async function handleOnSubmit(e) {
        e.preventDefault();
        if (verified) {
            const formData = {};
            formData['formType'] = "setuscholarshiptest"; 
            formData['title'] = "SETU Scholarship Test 2025";
            Array.from(e.currentTarget.elements).forEach(field => {
                if (!field.name) return;
                if (field.type === "radio") {
                    if (field.checked) {
                        formData[field.name] = field.value;
                    }
                } else {
                    formData[field.name] = field.value;
                }
            });
       
             formData['countryCode'] = "+91";
             formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
             formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
             formData["imageFile"] = base64ImageToUpload;
             formData["photo"] = base64ImageToUpload.base64;
             const transform={fields:{...formData}};
             delete transform.fields["imageFile"];
             delete transform.fields["imagefile"];
                  console.log(transform.fields['accommodaTions']);
            // delete transform.fields['filename'];
            
             console.log(formData);
           
                           console.log(transform);
                           setumailcnfm(transform);
                           setIsLoading(true);
                           setunewuser(transform)
                               .then(response => {
                               //sessionStorage.setItem('paymentForm', JSON.stringify(transform));
              
                               setModalOtp(true);
                               setmodalOtpstatus(response.message);
                               window.grecaptcha.reset(setverified);
                               setverified(false);
                               
                               //window.location.href = `https://admissionsv1.shankariasacademy.com/tnpscPayment/Paymentscreen?${(paymentData)}`;
                               setvaluephno(undefined);
                               document.getElementById("setuscholarshiptest").reset();
                               setIsLoading(false);
             
                               })
                                .catch(error => {
                               setModalOtp(true);
                               setmodalOtpstatus("failure");
                               window.grecaptcha.reset(setverified);
                               setverified(false);
                               setIsLoading(false);
                })
              }
             
           

        
        else {
            setcaptchaerror(true);
            setTimeout(() => {
                setcaptchaerror(false);
            }, 3000);
        }
    }

    
   
    return (
        <>
               {/*<ErrorModal show={errorMsg}  onHide={() => setErrorMsg(false)} /> */}
            {isLoading &&
                <div class="APIPreLoader" id="APIPreLoader">
                    <div class="loader">Loading...</div>
                </div>
            }
            <Otpverification show={modalOtp} title={modalOtpstatus} exceptionMessage={modalOtpExceptionMessage} frompage="setuscholarshiptest" onHide={() => setModalOtp(false)} />
            <section className=""style={{ background: "#FFF2F2 0% 0% no-repeat padding-box", opacity: "1" }}>
            <div className="container pt-3">
                <div className="row mx-auto pt-3" >
                    <div className="col">

                    

                            <div className="col-12 mx-auto">
                                <h2 className={`${styles.contactheader}`}>Registration&nbsp;&nbsp;&nbsp;<span className={`${styles.acheiverrank2} mb-0`} style={{color: '#DB1B0D'}}>(Registration is mandatory to attend the SETU Scholarship Test  2025)</span></h2>
                                <form onSubmit={handleOnSubmit} id="setuscholarshiptest" autoComplete="off">

                                    <div className="row pt-4">

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4 pt-4">
                                                <input type="text" className={`${styles.acheiverrank1} form-control`} placeholder="Name*" autoComplete="off" name="name" minLength="1"  required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4 pt-4">
                                                <input type="email" className={`${styles.acheiverrank1} form-control`} placeholder="Email Address*" title="Please enter a valid email address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4 pt-4">
                                                <input type="tel" className={`${styles.acheiverrank1} form-control`} name="phoneNo" placeholder="Phone No*" pattern="[0-9]{10}" maxlength="10" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4 ">
                                                 <div className="mb-4 ">
                                                    <label className={`${styles.acheiverrank1} form-check-label `}> Date of Birth <sup className= {`${styles.dot2}`}>*</sup></label>
                                                    <input  type="date" className={`${styles.acheiverrank1} form-control`}  name="dateofbirth"   required />
                                                </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                                            <label label className={`${styles.acheiverrank1} form-check-label px-2`}> Gender <sup className= {`${styles.dot2}`}>*</sup></label><br/>
                                                <input className="form-check-input" type="radio"
                                                    name="gender"
                                                    value="male"
                                                    id="male"
                                                    required
                                                />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Male">Male</label>    
                                                <input className="form-check-input" type="radio"
                                                    name="gender"
                                                    value="female"
                                                    id="male"
                                                    required
                                                />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Male">Female</label>
                                                    <input className="form-check-input" type="radio"
                                                        name="gender"
                                                        value="others"
                                                        id="male"
                                                        required
                                                    />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Female">Others</label>
                                       </div>

                                       <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4 pt-4">
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder="Permanent Address*"
                                                autoComplete="off"
                                                name="permanent_address"
                                                minLength="5"
                                                required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4 pt-4">
                                               <select className={`${styles.acheiverrank} form-select form-control`} name="state" autoComplete="off" required>
                                                <option value="">Select State<sup className= {`${styles.dot2}`}>*</sup></option>

                                                {/* States */}
                                                <option value="Andhra Pradesh">Andhra Pradesh</option>
                                                <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                                                <option value="Assam">Assam</option>
                                                <option value="Bihar">Bihar</option>
                                                <option value="Chhattisgarh">Chhattisgarh</option>
                                                <option value="Goa">Goa</option>
                                                <option value="Gujarat">Gujarat</option>
                                                <option value="Haryana">Haryana</option>
                                                <option value="Himachal Pradesh">Himachal Pradesh</option>
                                                <option value="Jharkhand">Jharkhand</option>
                                                <option value="Karnataka">Karnataka</option>
                                                <option value="Kerala">Kerala</option>
                                                <option value="Madhya Pradesh">Madhya Pradesh</option>
                                                <option value="Maharashtra">Maharashtra</option>
                                                <option value="Manipur">Manipur</option>
                                                <option value="Meghalaya">Meghalaya</option>
                                                <option value="Mizoram">Mizoram</option>
                                                <option value="Nagaland">Nagaland</option>
                                                <option value="Odisha">Odisha</option>
                                                <option value="Punjab">Punjab</option>
                                                <option value="Rajasthan">Rajasthan</option>
                                                <option value="Sikkim">Sikkim</option>
                                                <option value="Tamil Nadu">Tamil Nadu</option>
                                                <option value="Telangana">Telangana</option>
                                                <option value="Tripura">Tripura</option>
                                                <option value="Uttar Pradesh">Uttar Pradesh</option>
                                                <option value="Uttarakhand">Uttarakhand</option>
                                                <option value="West Bengal">West Bengal</option>

                                                {/* Union Territories */}
                                                <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                                                <option value="Chandigarh">Chandigarh</option>
                                                <option value="Dadra and Nagar Haveli and Daman and Diu">
                                                    Dadra and Nagar Haveli and Daman and Diu
                                                </option>
                                                <option value="Delhi">Delhi</option>
                                                <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                                                <option value="Ladakh">Ladakh</option>
                                                <option value="Lakshadweep">Lakshadweep</option>
                                                <option value="Puducherry">Puducherry</option>
                                                </select>
                                            </div>
                                       </div>

                                        <div className="col-12 col-xl-3 col-lg-4 pt-4">
                                            <div className="mb-4">
                                            
                                            <div className="mb-4 ">
                                                
                                            <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder="Your Native District"
                                                autoComplete="off"
                                                name="nativedistrict"
                                                minLength="2"
                                                required
                                                />
                                            </div>    
                                        
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            
                                            <div className="mb-4 pt-4">
                                                <label className={`${styles.acheiverrank1} form-check-label `}> Type of Disability  <sup className= {`${styles.dot2}`}>*</sup></label>
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder="As per RPwD Act 2016"
                                                autoComplete="off"
                                                name="typeofdisability"
                                                minLength="4"
                                                required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4 pt-4">
                                            
                                            <div className="mb-4 pt-4">
                                                
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder="Percentage of Disability *"
                                                autoComplete="off"
                                                name="percentageofdisability"
                                                minLength="2"
                                                required
                                                />
                                            </div>
                                        </div>

                                         <div className="col-12 col-xl-3 col-lg-4 pt-4">
                                            
                                            <div className="mb-4 ">
                                                 <label className={`${styles.acheiverrank1} form-check-label `}>Disability Certificate No <sup className= {`${styles.dot2}`}>*</sup></label>
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder=" Issuing Authority"
                                                autoComplete="off"
                                                name="disability_certificate_no"
                                                minLength="5"
                                                required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4 pt-4">
                                            
                                            <div className="mb-4 pt-4">
                                                
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder="Highest Educational Qualification*"
                                                autoComplete="off"
                                                name="education_qualification"
                                                minLength="3"
                                                required
                                                />
                                            </div>
                                        </div>

                                         <div className="col-12 col-xl-3 col-lg-4 ">
                                            
                                            <div className="mb-4 pt-4">
                                                
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder="Year of Passing*"
                                                autoComplete="off"
                                                name="year_of_passing"
                                                minLength="4"
                                                required
                                                />
                                            </div>
                                        </div>

                                         <div className="col-12 col-xl-3 col-lg-4 ">
                                            
                                            <div className="mb-4 pt-4">
                                                
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder="Medium of Education*"
                                                autoComplete="off"
                                                name="medium_of_education"
                                                minLength="5"
                                                required
                                                />
                                            </div>
                                        </div>

                                         <div className="col-12 col-xl-3 col-lg-4 ">
                                            
                                            <div className="mb-4 ">
                                                 <label className={`${styles.acheiverrank1} form-check-label `}> (If any / Courses ) <sup className= {`${styles.dot2}`}>*</sup></label>
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder="Additional Certifications"
                                                autoComplete="off"
                                                name="additional_certification"
                                                required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-3 ">
                                             <input type="hidden" name="accommodaTions" value={formData.selectedData} />
                                                <label
                                                    className={`${styles.mainsmock} form-check-label px-2`}
                                                    htmlFor="accommodations"
                                                >
                                                    Reasonable Accommodations
                                                </label>
                                                <div className="mb-4">
                                                    <MultiSelect
                                                  
                                                    options={accommodationOptions}
                                                    value={selected}
                                                    onChange={handleChange}
                                                    labelledBy="Select"
                                                    placeholder="Select accommodations"
                                                    hasSelectAll={false} 
                                                    />
                                                </div>
                                         </div>

                                        {/* <div className="col-12 col-xl-3 col-lg-4 pt-3">
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`}>
                                                Preferred Mode <sup className={`${styles.dot2}`}>*</sup>
                                            </label>
                                            <br />

                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="preferredmode"
                                                value="online"
                                                id="online"
                                                required
                                            />
                                            <label
                                                className={`${styles.acheiverrank1} form-check-label px-2`}
                                                htmlFor="online"
                                            >
                                                Online
                                            </label>
                                            
                                            <input
                                                className="form-check-input ms-3"
                                                type="radio"
                                                name="preferredmode"
                                                value="offline"
                                                id="offline"
                                                required
                                            />
                                            <label
                                                className={`${styles.acheiverrank1} form-check-label px-2`}
                                                htmlFor="offline"
                                            >
                                                Offline
                                            </label>
                                        </div> */}

                                         <div className="col-12 col-xl-4 col-lg-4 pt-3">
                                            
                                            <div className="mb-4 ">
                                                <label className={`${styles.acheiverrank1} form-check-label`}>
                                                Vision in public service <sup className= {`${styles.dot2}`}>*</sup>
                                                </label>
                                                <input
                                                type="text"
                                                className={`${styles.acheiverrank1} form-control`}
                                                placeholder=" Your long term career"
                                                autoComplete="off"
                                                name="your_longterm_career"
                                                required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-4 col-lg-4 pt-5">
                                            <div className="mb-4">
                                                <select className={`${styles.acheiverrank} form-select form-control`} name="annualincome" autoComplete="off" required>
                                                            <option value="" disabled selected hidden>Annual Family Income*</option>
                                                            <option value="Below ₹1 lakh ">Below ₹1 lakh </option>
                                                            <option value="₹1–3 lakh ">₹1–3 lakh</option>
                                                            <option value="₹3–6 lakh ">₹3–6 lakh</option>
                                                            <option value="Above ₹6 lakh">Above ₹6 lakh</option>
                                                            
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-4  col-lg-4 pt-5">
                                            <div className="mb-4">
                                            <select className={`${styles.acheiverrank} form-select form-control`} name="testcentre" autoComplete="off" required>
                                                <option value="" disabled selected hidden> Test Centre *</option>
                                                <option value="Chennai-Annanagar~9003190030">Annanagar</option>
                                                <option value="Chennai-Adyar~9025278278">Adyar</option>
                                                <option value="Delhi~8899180180">Delhi</option>
                                                <option value="Bengaluru~8197292121">Bengaluru</option>
                                                <option value="Thiruvananthapuram~7591902600">Thiruvananthapuram</option>
                                                <option value="Hyderabad~8309125825">Hyderabad</option>
                                                <option value="Trichy~9789664555">Trichy</option>
                                                <option value="Salem~8940080039">Salem</option>
                                                <option value="Madurai~9789622555">Madurai</option> 
                                                <option value="Online~9003190030">Online</option>                                         
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-4 col-lg-4 pt-2">
                                            <div className="mb-4">
                                                <label className={`${styles.acheiverrank1} form-check-label`}>
                                                Any existing scholarships or financial aid?<sup className= {`${styles.dot2}`}>*</sup>
                                                </label>

                                                {/* Yes / No Options */}
                                                <div className="d-flex align-items-center mt-2">
                                                <div className="form-check me-3">
                                                    <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="scholarship_aid"
                                                    id="scholarshipYes"
                                                    value="Yes"
                                                    checked={hasScholarship === "Yes"}
                                                    onChange={(e) => setHasScholarship(e.target.value)}
                                                    required
                                                    />
                                                    <label className="form-check-label" htmlFor="scholarshipYes">
                                                    Yes
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="scholarship_aid"
                                                    id="scholarshipNo"
                                                    value="No"
                                                    checked={hasScholarship === "No"}
                                                    onChange={(e) => setHasScholarship(e.target.value)}
                                                    required
                                                    />
                                                    <label className="form-check-label" htmlFor="scholarshipNo">
                                                    No
                                                    </label>
                                                </div>
                                                </div>

                                                {/* Details if Yes */}
                                                <div className="mt-3">
                                                <textarea
                                                    className={`${styles.acheiverrank1} form-control`}
                                                    placeholder="If yes, please provide details..."
                                                    name="scholarship_details"
                                                    rows="3"
                                                    maxLength="300"
                                                    disabled={hasScholarship === "No"}
                                                    required={hasScholarship === "Yes"}
                                                ></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-4 col-lg-4 pt-2">
                                            <div className="mb-4">
                                                <label className={`${styles.acheiverrank1} form-check-label`}>
                                                Have you attempted UPSC CSE before? <sup className={`${styles.dot2}`}>*</sup>
                                                </label>

                                                {/* Yes / No Options */}
                                                <div className="d-flex align-items-center mt-2">
                                                <div className="form-check me-3">
                                                    <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="attempted_upsc"
                                                    id="attemptYes"
                                                    value="Yes"
                                                    checked={attempted === "Yes"}
                                                    onChange={(e) => setAttempted(e.target.value)}
                                                    required
                                                    />
                                                    <label className="form-check-label" htmlFor="attemptYes">
                                                    Yes
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="attempted_upsc"
                                                    id="attemptNo"
                                                    value="No"
                                                    checked={attempted === "No"}
                                                    onChange={(e) => setAttempted(e.target.value)}
                                                    required
                                                    />
                                                    <label className="form-check-label" htmlFor="attemptNo">
                                                    No
                                                    </label>
                                                </div>
                                                </div>

                                                {/* Details if Yes */}
                                                <div className="mt-3">
                                                <textarea
                                                    className={`${styles.acheiverrank1} form-control`}
                                                    placeholder="If yes, please provide details..."
                                                    name="upsc_attempt_details"
                                                    rows="3"
                                                    maxLength="300"
                                                    disabled={attempted === "No"}
                                                ></textarea>
                                                
                                                </div>
                                            </div>
                                        </div>

                                         <div className="col-12 col-xl-4 col-lg-4 pt-4">
                                            <div className="mb-4">
                                                <label className={`${styles.acheiverrank1} form-check-label`}>
                                                 Why do you want to prepare for the UPSC Civil Services Examination? 
                                                (Max 200 words) <sup className= {`${styles.dot2}`}>*</sup>
                                                </label>
                                                <textarea
                                                    className={`${styles.acheiverrank1} form-control`}
                                                    placeholder="Write your answer here..."
                                                    name="upsc_preparation_reason"
                                                    rows="3"
                                                    maxLength="300"
                                                ></textarea>
                                               
                                            </div>
                                        </div>

                                       

                                    <div className="col-12 col-xl-4 col-lg-4 mb-3 pt-4">
                                          <label
                                            className={`${styles.mainsmock} form-check-label px-2 py-2`}
                                            htmlFor="Offline"
                                          >
                                            Select your passport size photo<sup className= {`${styles.dot2}`}>*</sup>
                                          </label>
                                        <div className="mb-4">
                                            <div className="input-group d-block">
                                              <div className="form-group">
                                                <div className="input-group">
                                                  <input
                                                    type="text"
                                                    id="fileindex"
                                                    name="filename"
                                                    className="form-control"
                                                    placeholder="Photo"
                                                    readOnly
                                                    required
                                                    style={{
                                                      display: "none",
                                                    }}
                                                  />
                                                  <span
                                                    className="input-group-btn"
                                                    style={{
                                                      border: "1px solid #D9DFE6",
                                                      backgroundColor: "#fff",
                                                      borderRadius: "50%", 
                                                      overflow: "hidden", 
                                                      width: "104px",
                                                      height: "100px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      margin: "-5px 69px",
                                                    }}
                                                  >
                                                    <div className={`${styles.customFileUploader} btn btn-default`}>
                                                      <input
                                                        type="file"
                                                        className={`${styles.selected}`}
                                                        name="imagefile"
                                                        id="imagefile"
                                                        onChange={(e) => imageUpload(e)}
                                                        accept="image/x-png,image/jpeg"
                                                        required
                                                        style={{
                                                          position: "absolute",
                                                          width: "80px",
                                                          height: "80px",
                                                          opacity: 0,
                                                          cursor: "pointer",
                                                        }}
                                                      />
                                                      <i className="bi bi-upload" style={{ fontSize: "24px" }}></i>
                                                    </div>
                                                  </span>
                                                </div>
                                              </div>
                                              <span className={`${styles.checkboxcontent} float-start`}>
                                                Jpg/Png format, less than 1MB
                                              </span>
                                            </div>
                                            {imgerror && (
                                              <div className="text-danger pt-1 captachafont">
                                                Please select a photo up to a size of 1 MB
                                              </div>
                                            )}
                                          </div>
                          </div>



                                          <div className="col-12 col-xl-5 col-lg-3 pt-3">
                                            <input className="form-check-input" type="checkbox" value="" id={styles.invalidCheck2} />
                                            <label className={`${styles.checkboxcontent1} form-check-label`} htmlFor="invalidCheck2">
                                                I hereby declare that the information provided above is true to the best of my knowledge and I will abide by the rules of the SETU Scholarship Programme.
                                            </label>

                                             <div className="me-3 mt-2">
                                                <ReCAPTCHA className={`${styles.captcha}`}
                                                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                                                    onChange={onChange}

                                                />
                                                <div className="">
                                                    {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className=" col-12 col-xl-3 col-lg-3 pt-3">
                                           

                                            <div className="my-auto">
                                                <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
                                            </div>

                                            
                                        </div>

                                    </div>

                                </form>

                            </div>

                        </div>
  
                    </div>
                    </div>
            </section>
            
    <style jsx>{`
        input[type="date"] {
          color: #000;
        }
      `}</style>
        </>
    )
}
export default Classroom_form;